/* @ngInject */
const myWagonDisplayMovements = (
  toaster,
  valueHandler,
  wagonUtils,
  $$movement
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
    },
    template: require('./myWagonDisplayMovements.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.movements = null
      $scope.displayMovements = false

      $scope.toggleDisplay = async () => {
        $scope.displayMovements = !$scope.displayMovements

        if ($scope.displayMovements && valueHandler.isNull($scope.movements)) {
          const data = {}
          data.wagonId = wagonUtils.stringToId($scope.myWagon.id)
          data.park = true
          data.unpark = true
          data.move = true

          try {
            const response = await $$movement.request.getBySearch(data)
            $scope.movements = response.movements
          } catch (error) {
            toaster.error(error)
          }
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => { },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myWagonDisplayMovements



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/display/myWagonDisplayMovements.js